module.exports = __webpack_public_path__ + "static/media/Tarots_01_All-16.96fd944f.svg";